<template>
  <div :class="`text-${sectionData.align} q-my-sm q-mx-sm`">
    <q-btn
      :class="sectionData.class"
      unelevated
      no-caps
      size="md"
      @click="invokeComponent"
      :label="sectionData.label"
      :icon="sectionData.icon"
    >
    </q-btn>
  </div>
</template>

<script>
export default {
  name: "DPdf",
  props: {
    sectionData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    invokeComponent() {
      this.$emit("invokeComponent", {
        component: this.sectionData.component,
        id: this.sectionData.id,
      });
    },
  },
};
</script>
